import { call, put, takeLatest, all } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes/phoneNumberCapture';
import config from 'config';
import apiClient from '../helpers/apiClient';

let _client = null;
function* submitPhoneNumber({ data: { jsonData, phNo, expiry } }) {
    const url = config.apiPath.campaignData + '/MobileData';
    const successAction = { type: actionTypes.PHONE_NUMBER_CAPTURE_SUCCESS };
    const errorAction = { type: actionTypes.PHONE_NUMBER_CAPTURE_FAILED };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => _client.post(url, jsonData));
        successAction.data = data;
        successAction.phNo = phNo;
        successAction.expiry = expiry;
        yield put(successAction);
    } catch (err) {
        errorAction.error = err;
        yield put(errorAction);
    }
}

export function* runPhoneNumberCaptureCalls(client) {
    _client = client ? Object.assign({}, client) : apiClient();
    yield all([
        takeLatest(actionTypes.PHONE_NUMBER_CAPTURE_SUBMIT, submitPhoneNumber)
    ]);
}
